//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IManagementClient {
    /**
     * Buscar órdenes
     * @param customerEmail (optional) Email del cliente para filtrar órdenes
     * @param seller (optional) Identificador o identificadores de sellers separados por coma
     * @param amountMin (optional) Monto mínimo del total de la orden
     * @param amountMax (optional) Monto máximo del total de la orden
     * @param page (optional) Índice de página (inicia en 0)
     * @param size (optional) Cantidad de elementos por página
     * @param sort (optional) Formato: propiedad,(asc|desc)
     * @param status (optional) Estado de la orden
     * @param createdDateFrom (optional) Fecha de creación desde
     * @param createdDateTo (optional) Fecha de creación hasta
     * @param authorizationDateFrom (optional) Fecha de autorización desde
     * @param authorizationDateTo (optional) Fecha de autorización hasta
     * @param deliveryDateFrom (optional) Fecha de entrega desde
     * @param deliveryDateTo (optional) Fecha de entrega hasta
     * @param modality (optional) Modalidad de la orden
     * @param paymentMethod (optional) Método de pago
     * @param safetyPayCode (optional) Código de SafetyPay
     * @param transactionId (optional) ID de la transacción
     * @param orderId (optional) ID de la orden
     * @param sku (optional) SKU del producto
     * @param currency (optional) Moneda de la orden
     * @param receiptType (optional) Tipo de recibo
     * @param incomplete (optional) Indica si la orden está incompleta
     * @return Listado de órdenes obtenido exitosamente
     */
    searchOrders(customerEmail?: string | undefined, seller?: string | undefined, amountMin?: number | undefined, amountMax?: number | undefined, page?: number | undefined, size?: number | undefined, sort?: string[] | undefined, status?: string | undefined, createdDateFrom?: string | undefined, createdDateTo?: string | undefined, authorizationDateFrom?: string | undefined, authorizationDateTo?: string | undefined, deliveryDateFrom?: string | undefined, deliveryDateTo?: string | undefined, modality?: string | undefined, paymentMethod?: string | undefined, safetyPayCode?: string | undefined, transactionId?: string | undefined, orderId?: string | undefined, sku?: string | undefined, currency?: string | undefined, receiptType?: string | undefined, incomplete?: boolean | undefined): Observable<SearchOrdersResponseDto>;
    /**
     * Obtener detalle de una orden
     * @param orderId Identificador único de la orden
     * @return Detalle de la orden obtenido exitosamente
     */
    getOrderDetail(orderId: string): Observable<OrderDetailResponseDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ManagementClient implements IManagementClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Buscar órdenes
     * @param customerEmail (optional) Email del cliente para filtrar órdenes
     * @param seller (optional) Identificador o identificadores de sellers separados por coma
     * @param amountMin (optional) Monto mínimo del total de la orden
     * @param amountMax (optional) Monto máximo del total de la orden
     * @param page (optional) Índice de página (inicia en 0)
     * @param size (optional) Cantidad de elementos por página
     * @param sort (optional) Formato: propiedad,(asc|desc)
     * @param status (optional) Estado de la orden
     * @param createdDateFrom (optional) Fecha de creación desde
     * @param createdDateTo (optional) Fecha de creación hasta
     * @param authorizationDateFrom (optional) Fecha de autorización desde
     * @param authorizationDateTo (optional) Fecha de autorización hasta
     * @param deliveryDateFrom (optional) Fecha de entrega desde
     * @param deliveryDateTo (optional) Fecha de entrega hasta
     * @param modality (optional) Modalidad de la orden
     * @param paymentMethod (optional) Método de pago
     * @param safetyPayCode (optional) Código de SafetyPay
     * @param transactionId (optional) ID de la transacción
     * @param orderId (optional) ID de la orden
     * @param sku (optional) SKU del producto
     * @param currency (optional) Moneda de la orden
     * @param receiptType (optional) Tipo de recibo
     * @param incomplete (optional) Indica si la orden está incompleta
     * @return Listado de órdenes obtenido exitosamente
     */
    searchOrders(customerEmail?: string | undefined, seller?: string | undefined, amountMin?: number | undefined, amountMax?: number | undefined, page?: number | undefined, size?: number | undefined, sort?: string[] | undefined, status?: string | undefined, createdDateFrom?: string | undefined, createdDateTo?: string | undefined, authorizationDateFrom?: string | undefined, authorizationDateTo?: string | undefined, deliveryDateFrom?: string | undefined, deliveryDateTo?: string | undefined, modality?: string | undefined, paymentMethod?: string | undefined, safetyPayCode?: string | undefined, transactionId?: string | undefined, orderId?: string | undefined, sku?: string | undefined, currency?: string | undefined, receiptType?: string | undefined, incomplete?: boolean | undefined): Observable<SearchOrdersResponseDto> {
        let url_ = this.baseUrl + "/hub/management/orders/v3?";
        if (customerEmail === null)
            throw new globalThis.Error("The parameter 'customerEmail' cannot be null.");
        else if (customerEmail !== undefined)
            url_ += "customerEmail=" + encodeURIComponent("" + customerEmail) + "&";
        if (seller === null)
            throw new globalThis.Error("The parameter 'seller' cannot be null.");
        else if (seller !== undefined)
            url_ += "seller=" + encodeURIComponent("" + seller) + "&";
        if (amountMin === null)
            throw new globalThis.Error("The parameter 'amountMin' cannot be null.");
        else if (amountMin !== undefined)
            url_ += "amountMin=" + encodeURIComponent("" + amountMin) + "&";
        if (amountMax === null)
            throw new globalThis.Error("The parameter 'amountMax' cannot be null.");
        else if (amountMax !== undefined)
            url_ += "amountMax=" + encodeURIComponent("" + amountMax) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new globalThis.Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (sort === null)
            throw new globalThis.Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach(item => { url_ += "sort=" + encodeURIComponent("" + item) + "&"; });
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (createdDateFrom === null)
            throw new globalThis.Error("The parameter 'createdDateFrom' cannot be null.");
        else if (createdDateFrom !== undefined)
            url_ += "createdDateFrom=" + encodeURIComponent("" + createdDateFrom) + "&";
        if (createdDateTo === null)
            throw new globalThis.Error("The parameter 'createdDateTo' cannot be null.");
        else if (createdDateTo !== undefined)
            url_ += "createdDateTo=" + encodeURIComponent("" + createdDateTo) + "&";
        if (authorizationDateFrom === null)
            throw new globalThis.Error("The parameter 'authorizationDateFrom' cannot be null.");
        else if (authorizationDateFrom !== undefined)
            url_ += "authorizationDateFrom=" + encodeURIComponent("" + authorizationDateFrom) + "&";
        if (authorizationDateTo === null)
            throw new globalThis.Error("The parameter 'authorizationDateTo' cannot be null.");
        else if (authorizationDateTo !== undefined)
            url_ += "authorizationDateTo=" + encodeURIComponent("" + authorizationDateTo) + "&";
        if (deliveryDateFrom === null)
            throw new globalThis.Error("The parameter 'deliveryDateFrom' cannot be null.");
        else if (deliveryDateFrom !== undefined)
            url_ += "deliveryDateFrom=" + encodeURIComponent("" + deliveryDateFrom) + "&";
        if (deliveryDateTo === null)
            throw new globalThis.Error("The parameter 'deliveryDateTo' cannot be null.");
        else if (deliveryDateTo !== undefined)
            url_ += "deliveryDateTo=" + encodeURIComponent("" + deliveryDateTo) + "&";
        if (modality === null)
            throw new globalThis.Error("The parameter 'modality' cannot be null.");
        else if (modality !== undefined)
            url_ += "modality=" + encodeURIComponent("" + modality) + "&";
        if (paymentMethod === null)
            throw new globalThis.Error("The parameter 'paymentMethod' cannot be null.");
        else if (paymentMethod !== undefined)
            url_ += "paymentMethod=" + encodeURIComponent("" + paymentMethod) + "&";
        if (safetyPayCode === null)
            throw new globalThis.Error("The parameter 'safetyPayCode' cannot be null.");
        else if (safetyPayCode !== undefined)
            url_ += "safetyPayCode=" + encodeURIComponent("" + safetyPayCode) + "&";
        if (transactionId === null)
            throw new globalThis.Error("The parameter 'transactionId' cannot be null.");
        else if (transactionId !== undefined)
            url_ += "transactionId=" + encodeURIComponent("" + transactionId) + "&";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (sku === null)
            throw new globalThis.Error("The parameter 'sku' cannot be null.");
        else if (sku !== undefined)
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        if (currency === null)
            throw new globalThis.Error("The parameter 'currency' cannot be null.");
        else if (currency !== undefined)
            url_ += "currency=" + encodeURIComponent("" + currency) + "&";
        if (receiptType === null)
            throw new globalThis.Error("The parameter 'receiptType' cannot be null.");
        else if (receiptType !== undefined)
            url_ += "receiptType=" + encodeURIComponent("" + receiptType) + "&";
        if (incomplete === null)
            throw new globalThis.Error("The parameter 'incomplete' cannot be null.");
        else if (incomplete !== undefined)
            url_ += "incomplete=" + encodeURIComponent("" + incomplete) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchOrdersResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchOrdersResponseDto>;
        }));
    }

    protected processSearchOrders(response: HttpResponseBase): Observable<SearchOrdersResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchOrdersResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Missing or invalid access token", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Obtener detalle de una orden
     * @param orderId Identificador único de la orden
     * @return Detalle de la orden obtenido exitosamente
     */
    getOrderDetail(orderId: string): Observable<OrderDetailResponseDto> {
        let url_ = this.baseUrl + "/hub/management/orders/v3/{orderId}";
        if (orderId === undefined || orderId === null)
            throw new globalThis.Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderDetailResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderDetailResponseDto>;
        }));
    }

    protected processGetOrderDetail(response: HttpResponseBase): Observable<OrderDetailResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDetailResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Missing or invalid access token", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class SearchOrdersResponseDto implements ISearchOrdersResponseDto {
    items!: OrderSummaryDto[];
    page!: PageDto;
    summary!: SummaryDto;

    [key: string]: any;

    constructor(data?: ISearchOrdersResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
            this.page = new PageDto();
            this.summary = new SummaryDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrderSummaryDto.fromJS(item));
            }
            this.page = _data["page"] ? PageDto.fromJS(_data["page"]) : new PageDto();
            this.summary = _data["summary"] ? SummaryDto.fromJS(_data["summary"]) : new SummaryDto();
        }
    }

    static fromJS(data: any): SearchOrdersResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchOrdersResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["page"] = this.page ? this.page.toJSON() : undefined as any;
        data["summary"] = this.summary ? this.summary.toJSON() : undefined as any;
        return data;
    }
}

export interface ISearchOrdersResponseDto {
    items: OrderSummaryDto[];
    page: PageDto;
    summary: SummaryDto;

    [key: string]: any;
}

export class OrderDetailResponseDto implements IOrderDetailResponseDto {
    id!: string;
    sequence!: number;
    orderGroup!: string;
    sellerOrderRefId!: string;
    seller!: SellerDto;
    status!: OrderDetailResponseDtoStatus;
    createdDate!: string;
    lastModifiedDate!: string;
    totals!: TotalsDto;
    marketingData?: MarketingDataDto;
    saleContext?: SaleContextDto;
    customer!: CustomerDto;
    shippingAddress!: ShippingAddressDto;
    receiver!: ReceiverDto;
    billing!: BillingDto;
    payment!: PaymentDto;
    shipments!: ShipmentDto[];

    [key: string]: any;

    constructor(data?: IOrderDetailResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.seller = new SellerDto();
            this.totals = new TotalsDto();
            this.customer = new CustomerDto();
            this.shippingAddress = new ShippingAddressDto();
            this.receiver = new ReceiverDto();
            this.billing = new BillingDto();
            this.payment = new PaymentDto();
            this.shipments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.sequence = _data["sequence"];
            this.orderGroup = _data["orderGroup"];
            this.sellerOrderRefId = _data["sellerOrderRefId"];
            this.seller = _data["seller"] ? SellerDto.fromJS(_data["seller"]) : new SellerDto();
            this.status = _data["status"];
            this.createdDate = _data["createdDate"];
            this.lastModifiedDate = _data["lastModifiedDate"];
            this.totals = _data["totals"] ? TotalsDto.fromJS(_data["totals"]) : new TotalsDto();
            this.marketingData = _data["marketingData"] ? MarketingDataDto.fromJS(_data["marketingData"]) : undefined as any;
            this.saleContext = _data["saleContext"] ? SaleContextDto.fromJS(_data["saleContext"]) : undefined as any;
            this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : new CustomerDto();
            this.shippingAddress = _data["shippingAddress"] ? ShippingAddressDto.fromJS(_data["shippingAddress"]) : new ShippingAddressDto();
            this.receiver = _data["receiver"] ? ReceiverDto.fromJS(_data["receiver"]) : new ReceiverDto();
            this.billing = _data["billing"] ? BillingDto.fromJS(_data["billing"]) : new BillingDto();
            this.payment = _data["payment"] ? PaymentDto.fromJS(_data["payment"]) : new PaymentDto();
            if (Array.isArray(_data["shipments"])) {
                this.shipments = [] as any;
                for (let item of _data["shipments"])
                    this.shipments!.push(ShipmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderDetailResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["sequence"] = this.sequence;
        data["orderGroup"] = this.orderGroup;
        data["sellerOrderRefId"] = this.sellerOrderRefId;
        data["seller"] = this.seller ? this.seller.toJSON() : undefined as any;
        data["status"] = this.status;
        data["createdDate"] = this.createdDate;
        data["lastModifiedDate"] = this.lastModifiedDate;
        data["totals"] = this.totals ? this.totals.toJSON() : undefined as any;
        data["marketingData"] = this.marketingData ? this.marketingData.toJSON() : undefined as any;
        data["saleContext"] = this.saleContext ? this.saleContext.toJSON() : undefined as any;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["shippingAddress"] = this.shippingAddress ? this.shippingAddress.toJSON() : undefined as any;
        data["receiver"] = this.receiver ? this.receiver.toJSON() : undefined as any;
        data["billing"] = this.billing ? this.billing.toJSON() : undefined as any;
        data["payment"] = this.payment ? this.payment.toJSON() : undefined as any;
        if (Array.isArray(this.shipments)) {
            data["shipments"] = [];
            for (let item of this.shipments)
                data["shipments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOrderDetailResponseDto {
    id: string;
    sequence: number;
    orderGroup: string;
    sellerOrderRefId: string;
    seller: SellerDto;
    status: OrderDetailResponseDtoStatus;
    createdDate: string;
    lastModifiedDate: string;
    totals: TotalsDto;
    marketingData?: MarketingDataDto;
    saleContext?: SaleContextDto;
    customer: CustomerDto;
    shippingAddress: ShippingAddressDto;
    receiver: ReceiverDto;
    billing: BillingDto;
    payment: PaymentDto;
    shipments: ShipmentDto[];

    [key: string]: any;
}

export class OrderSummaryDto implements IOrderSummaryDto {
    id!: string;
    sequence!: number;
    orderGroup!: string;
    seller!: SellerDto;
    status!: OrderSummaryDtoStatus;
    createdDate!: string;
    lastModifiedDate!: string;
    customer!: CustomerDto;
    shippingAddress!: ShippingAddressDto;
    billing!: BillingDto;
    payment!: PaymentDto | undefined;
    marketingData!: MarketingDataDto;
    checkoutTransactionId!: string;
    sellerOrderRefId!: string;
    receiver!: ReceiverDto;
    saleContext!: ShippingSettingsDto;
    shipments!: ShipmentDto[];
    totals!: TotalsDto;

    [key: string]: any;

    constructor(data?: IOrderSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.seller = new SellerDto();
            this.customer = new CustomerDto();
            this.shippingAddress = new ShippingAddressDto();
            this.billing = new BillingDto();
            this.marketingData = new MarketingDataDto();
            this.receiver = new ReceiverDto();
            this.saleContext = new ShippingSettingsDto();
            this.shipments = [];
            this.totals = new TotalsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.sequence = _data["sequence"];
            this.orderGroup = _data["orderGroup"];
            this.seller = _data["seller"] ? SellerDto.fromJS(_data["seller"]) : new SellerDto();
            this.status = _data["status"];
            this.createdDate = _data["createdDate"];
            this.lastModifiedDate = _data["lastModifiedDate"];
            this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : new CustomerDto();
            this.shippingAddress = _data["shippingAddress"] ? ShippingAddressDto.fromJS(_data["shippingAddress"]) : new ShippingAddressDto();
            this.billing = _data["billing"] ? BillingDto.fromJS(_data["billing"]) : new BillingDto();
            this.payment = _data["payment"] ? PaymentDto.fromJS(_data["payment"]) : undefined as any;
            this.marketingData = _data["marketingData"] ? MarketingDataDto.fromJS(_data["marketingData"]) : new MarketingDataDto();
            this.checkoutTransactionId = _data["checkoutTransactionId"];
            this.sellerOrderRefId = _data["sellerOrderRefId"];
            this.receiver = _data["receiver"] ? ReceiverDto.fromJS(_data["receiver"]) : new ReceiverDto();
            this.saleContext = _data["saleContext"] ? ShippingSettingsDto.fromJS(_data["saleContext"]) : new ShippingSettingsDto();
            if (Array.isArray(_data["shipments"])) {
                this.shipments = [] as any;
                for (let item of _data["shipments"])
                    this.shipments!.push(ShipmentDto.fromJS(item));
            }
            this.totals = _data["totals"] ? TotalsDto.fromJS(_data["totals"]) : new TotalsDto();
        }
    }

    static fromJS(data: any): OrderSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["sequence"] = this.sequence;
        data["orderGroup"] = this.orderGroup;
        data["seller"] = this.seller ? this.seller.toJSON() : undefined as any;
        data["status"] = this.status;
        data["createdDate"] = this.createdDate;
        data["lastModifiedDate"] = this.lastModifiedDate;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["shippingAddress"] = this.shippingAddress ? this.shippingAddress.toJSON() : undefined as any;
        data["billing"] = this.billing ? this.billing.toJSON() : undefined as any;
        data["payment"] = this.payment ? this.payment.toJSON() : undefined as any;
        data["marketingData"] = this.marketingData ? this.marketingData.toJSON() : undefined as any;
        data["checkoutTransactionId"] = this.checkoutTransactionId;
        data["sellerOrderRefId"] = this.sellerOrderRefId;
        data["receiver"] = this.receiver ? this.receiver.toJSON() : undefined as any;
        data["saleContext"] = this.saleContext ? this.saleContext.toJSON() : undefined as any;
        if (Array.isArray(this.shipments)) {
            data["shipments"] = [];
            for (let item of this.shipments)
                data["shipments"].push(item ? item.toJSON() : undefined as any);
        }
        data["totals"] = this.totals ? this.totals.toJSON() : undefined as any;
        return data;
    }
}

export interface IOrderSummaryDto {
    id: string;
    sequence: number;
    orderGroup: string;
    seller: SellerDto;
    status: OrderSummaryDtoStatus;
    createdDate: string;
    lastModifiedDate: string;
    customer: CustomerDto;
    shippingAddress: ShippingAddressDto;
    billing: BillingDto;
    payment: PaymentDto | undefined;
    marketingData: MarketingDataDto;
    checkoutTransactionId: string;
    sellerOrderRefId: string;
    receiver: ReceiverDto;
    saleContext: ShippingSettingsDto;
    shipments: ShipmentDto[];
    totals: TotalsDto;

    [key: string]: any;
}

export class PageDto implements IPageDto {
    /** Número de página (inicia en 0) */
    number!: number;
    /** Tamaño de página */
    size!: number;
    /** Total de elementos encontrados */
    totalElements!: number;
    /** Total de páginas */
    totalPages!: number;
    /** Indica si la página está vacía */
    empty!: boolean;

    [key: string]: any;

    constructor(data?: IPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.number = _data["number"];
            this.size = _data["size"];
            this.totalElements = _data["totalElements"];
            this.totalPages = _data["totalPages"];
            this.empty = _data["empty"];
        }
    }

    static fromJS(data: any): PageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["number"] = this.number;
        data["size"] = this.size;
        data["totalElements"] = this.totalElements;
        data["totalPages"] = this.totalPages;
        data["empty"] = this.empty;
        return data;
    }
}

export interface IPageDto {
    /** Número de página (inicia en 0) */
    number: number;
    /** Tamaño de página */
    size: number;
    /** Total de elementos encontrados */
    totalElements: number;
    /** Total de páginas */
    totalPages: number;
    /** Indica si la página está vacía */
    empty: boolean;

    [key: string]: any;
}

export class SummaryDto implements ISummaryDto {
    averageTicket!: number;
    grossTotal!: number;
    totalOrders!: number;
    currency!: string;

    [key: string]: any;

    constructor(data?: ISummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.averageTicket = _data["averageTicket"];
            this.grossTotal = _data["grossTotal"];
            this.totalOrders = _data["totalOrders"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): SummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["averageTicket"] = this.averageTicket;
        data["grossTotal"] = this.grossTotal;
        data["totalOrders"] = this.totalOrders;
        data["currency"] = this.currency;
        return data;
    }
}

export interface ISummaryDto {
    averageTicket: number;
    grossTotal: number;
    totalOrders: number;
    currency: string;

    [key: string]: any;
}

export class SellerDto implements ISellerDto {
    sellerId!: string;
    sellerName?: string;
    prices!: SellerPriceDto[];
    stock?: SellerStockDto;
    availableUnits?: number;

    [key: string]: any;

    constructor(data?: ISellerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.prices = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.sellerId = _data["sellerId"];
            this.sellerName = _data["sellerName"];
            if (Array.isArray(_data["prices"])) {
                this.prices = [] as any;
                for (let item of _data["prices"])
                    this.prices!.push(SellerPriceDto.fromJS(item));
            }
            this.stock = _data["stock"] ? SellerStockDto.fromJS(_data["stock"]) : undefined as any;
            this.availableUnits = _data["availableUnits"];
        }
    }

    static fromJS(data: any): SellerDto {
        data = typeof data === 'object' ? data : {};
        let result = new SellerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["sellerId"] = this.sellerId;
        data["sellerName"] = this.sellerName;
        if (Array.isArray(this.prices)) {
            data["prices"] = [];
            for (let item of this.prices)
                data["prices"].push(item ? item.toJSON() : undefined as any);
        }
        data["stock"] = this.stock ? this.stock.toJSON() : undefined as any;
        data["availableUnits"] = this.availableUnits;
        return data;
    }
}

export interface ISellerDto {
    sellerId: string;
    sellerName?: string;
    prices: SellerPriceDto[];
    stock?: SellerStockDto;
    availableUnits?: number;

    [key: string]: any;
}

export class TotalsDto implements ITotalsDto {
    currency!: TotalsDtoCurrency;
    subtotal!: number;
    totalDiscount!: number;
    shippingCost!: number;
    total!: number;

    [key: string]: any;

    constructor(data?: ITotalsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.currency = _data["currency"];
            this.subtotal = _data["subtotal"];
            this.totalDiscount = _data["totalDiscount"];
            this.shippingCost = _data["shippingCost"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): TotalsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TotalsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["currency"] = this.currency;
        data["subtotal"] = this.subtotal;
        data["totalDiscount"] = this.totalDiscount;
        data["shippingCost"] = this.shippingCost;
        data["total"] = this.total;
        return data;
    }
}

export interface ITotalsDto {
    currency: TotalsDtoCurrency;
    subtotal: number;
    totalDiscount: number;
    shippingCost: number;
    total: number;

    [key: string]: any;
}

export class MarketingDataDto implements IMarketingDataDto {
    utmSource!: string;
    utmMedium!: string;
    utmCampaign!: string;

    [key: string]: any;

    constructor(data?: IMarketingDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.utmSource = _data["utmSource"];
            this.utmMedium = _data["utmMedium"];
            this.utmCampaign = _data["utmCampaign"];
        }
    }

    static fromJS(data: any): MarketingDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["utmSource"] = this.utmSource;
        data["utmMedium"] = this.utmMedium;
        data["utmCampaign"] = this.utmCampaign;
        return data;
    }
}

export interface IMarketingDataDto {
    utmSource: string;
    utmMedium: string;
    utmCampaign: string;

    [key: string]: any;
}

export class SaleContextDto implements ISaleContextDto {
    code!: string;
    salesChannel!: string;
    branchCode!: string;
    salesPersonCode!: string;

    [key: string]: any;

    constructor(data?: ISaleContextDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.code = _data["code"];
            this.salesChannel = _data["salesChannel"];
            this.branchCode = _data["branchCode"];
            this.salesPersonCode = _data["salesPersonCode"];
        }
    }

    static fromJS(data: any): SaleContextDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaleContextDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["code"] = this.code;
        data["salesChannel"] = this.salesChannel;
        data["branchCode"] = this.branchCode;
        data["salesPersonCode"] = this.salesPersonCode;
        return data;
    }
}

export interface ISaleContextDto {
    code: string;
    salesChannel: string;
    branchCode: string;
    salesPersonCode: string;

    [key: string]: any;
}

export class CustomerDto implements ICustomerDto {
    customerId!: string;
    email!: string;
    names!: string;
    lastNames!: string;
    phoneNumber!: string;
    documentType!: CustomerDtoDocumentType;
    documentNumber!: string;
    shouldObfuscate!: boolean;

    [key: string]: any;

    constructor(data?: ICustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.customerId = _data["customerId"];
            this.email = _data["email"];
            this.names = _data["names"];
            this.lastNames = _data["lastNames"];
            this.phoneNumber = _data["phoneNumber"];
            this.documentType = _data["documentType"];
            this.documentNumber = _data["documentNumber"];
            this.shouldObfuscate = _data["shouldObfuscate"];
        }
    }

    static fromJS(data: any): CustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["customerId"] = this.customerId;
        data["email"] = this.email;
        data["names"] = this.names;
        data["lastNames"] = this.lastNames;
        data["phoneNumber"] = this.phoneNumber;
        data["documentType"] = this.documentType;
        data["documentNumber"] = this.documentNumber;
        data["shouldObfuscate"] = this.shouldObfuscate;
        return data;
    }
}

export interface ICustomerDto {
    customerId: string;
    email: string;
    names: string;
    lastNames: string;
    phoneNumber: string;
    documentType: CustomerDtoDocumentType;
    documentNumber: string;
    shouldObfuscate: boolean;

    [key: string]: any;
}

export class ShippingAddressDto implements IShippingAddressDto {
    address!: string;
    addressNumber!: string;
    reference?: string;
    district!: string;
    province!: string;
    department!: string;
    ubigeo!: string;
    latitude?: number;
    longitude?: number;
    zone?: string;

    [key: string]: any;

    constructor(data?: IShippingAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.address = _data["address"];
            this.addressNumber = _data["addressNumber"];
            this.reference = _data["reference"];
            this.district = _data["district"];
            this.province = _data["province"];
            this.department = _data["department"];
            this.ubigeo = _data["ubigeo"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.zone = _data["zone"];
        }
    }

    static fromJS(data: any): ShippingAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["address"] = this.address;
        data["addressNumber"] = this.addressNumber;
        data["reference"] = this.reference;
        data["district"] = this.district;
        data["province"] = this.province;
        data["department"] = this.department;
        data["ubigeo"] = this.ubigeo;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["zone"] = this.zone;
        return data;
    }
}

export interface IShippingAddressDto {
    address: string;
    addressNumber: string;
    reference?: string;
    district: string;
    province: string;
    department: string;
    ubigeo: string;
    latitude?: number;
    longitude?: number;
    zone?: string;

    [key: string]: any;
}

export class ReceiverDto implements IReceiverDto {
    firstName!: string;
    lastName!: string;
    phone!: string;
    isSameClient!: boolean;

    [key: string]: any;

    constructor(data?: IReceiverDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phone = _data["phone"];
            this.isSameClient = _data["isSameClient"];
        }
    }

    static fromJS(data: any): ReceiverDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiverDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phone"] = this.phone;
        data["isSameClient"] = this.isSameClient;
        return data;
    }
}

export interface IReceiverDto {
    firstName: string;
    lastName: string;
    phone: string;
    isSameClient: boolean;

    [key: string]: any;
}

export class BillingDto implements IBillingDto {
    receiptType!: BillingDtoReceiptType;
    taxId?: string;
    legalName?: string;

    [key: string]: any;

    constructor(data?: IBillingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.receiptType = _data["receiptType"];
            this.taxId = _data["taxId"];
            this.legalName = _data["legalName"];
        }
    }

    static fromJS(data: any): BillingDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["receiptType"] = this.receiptType;
        data["taxId"] = this.taxId;
        data["legalName"] = this.legalName;
        return data;
    }
}

export interface IBillingDto {
    receiptType: BillingDtoReceiptType;
    taxId?: string;
    legalName?: string;

    [key: string]: any;
}

export class PaymentDto implements IPaymentDto {
    /** ID de la transacción */
    transactionId!: string;
    /** Estado del pago */
    status!: PaymentDtoStatus;
    /** Método de pago utilizado */
    methodType!: PaymentDtoMethodType;
    /** Método de pago utilizado */
    paymentMethod!: PaymentDtoPaymentMethod;
    card!: CardDto;
    /** Codigo del metodo de pago */
    paymentMethodCode!: string;
    /** Codigo del metodo de pago */
    processorCode!: string;
    /** Codigo del metodo de pago */
    processorMessage!: string;

    [key: string]: any;

    constructor(data?: IPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.card = new CardDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.transactionId = _data["transactionId"];
            this.status = _data["status"];
            this.methodType = _data["methodType"];
            this.paymentMethod = _data["paymentMethod"];
            this.card = _data["card"] ? CardDto.fromJS(_data["card"]) : new CardDto();
            this.paymentMethodCode = _data["paymentMethodCode"];
            this.processorCode = _data["processorCode"];
            this.processorMessage = _data["processorMessage"];
        }
    }

    static fromJS(data: any): PaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["transactionId"] = this.transactionId;
        data["status"] = this.status;
        data["methodType"] = this.methodType;
        data["paymentMethod"] = this.paymentMethod;
        data["card"] = this.card ? this.card.toJSON() : undefined as any;
        data["paymentMethodCode"] = this.paymentMethodCode;
        data["processorCode"] = this.processorCode;
        data["processorMessage"] = this.processorMessage;
        return data;
    }
}

export interface IPaymentDto {
    /** ID de la transacción */
    transactionId: string;
    /** Estado del pago */
    status: PaymentDtoStatus;
    /** Método de pago utilizado */
    methodType: PaymentDtoMethodType;
    /** Método de pago utilizado */
    paymentMethod: PaymentDtoPaymentMethod;
    card: CardDto;
    /** Codigo del metodo de pago */
    paymentMethodCode: string;
    /** Codigo del metodo de pago */
    processorCode: string;
    /** Codigo del metodo de pago */
    processorMessage: string;

    [key: string]: any;
}

export class ShipmentDto implements IShipmentDto {
    id!: string;
    sequence!: number;
    shipping!: ShippingConfigDto;
    shippingInformation!: ShippingInformationDto;
    items!: OrderItemDto[];
    totals!: TotalsDto;

    [key: string]: any;

    constructor(data?: IShipmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.shipping = new ShippingConfigDto();
            this.shippingInformation = new ShippingInformationDto();
            this.items = [];
            this.totals = new TotalsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.sequence = _data["sequence"];
            this.shipping = _data["shipping"] ? ShippingConfigDto.fromJS(_data["shipping"]) : new ShippingConfigDto();
            this.shippingInformation = _data["shippingInformation"] ? ShippingInformationDto.fromJS(_data["shippingInformation"]) : new ShippingInformationDto();
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrderItemDto.fromJS(item));
            }
            this.totals = _data["totals"] ? TotalsDto.fromJS(_data["totals"]) : new TotalsDto();
        }
    }

    static fromJS(data: any): ShipmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShipmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["sequence"] = this.sequence;
        data["shipping"] = this.shipping ? this.shipping.toJSON() : undefined as any;
        data["shippingInformation"] = this.shippingInformation ? this.shippingInformation.toJSON() : undefined as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totals"] = this.totals ? this.totals.toJSON() : undefined as any;
        return data;
    }
}

export interface IShipmentDto {
    id: string;
    sequence: number;
    shipping: ShippingConfigDto;
    shippingInformation: ShippingInformationDto;
    items: OrderItemDto[];
    totals: TotalsDto;

    [key: string]: any;
}

export class ShippingSettingsDto implements IShippingSettingsDto {
    /** Fecha de entrega más temprana entre todos los shipments */
    earliestDeliveryDate!: string;
    /** Fecha de entrega más tardía entre todos los shipments */
    latestDeliveryDate!: string;
    /** Modalidades de envío únicas presentes en la orden */
    modalities!: Modalities[];

    [key: string]: any;

    constructor(data?: IShippingSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.modalities = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.earliestDeliveryDate = _data["earliestDeliveryDate"];
            this.latestDeliveryDate = _data["latestDeliveryDate"];
            if (Array.isArray(_data["modalities"])) {
                this.modalities = [] as any;
                for (let item of _data["modalities"])
                    this.modalities!.push(item);
            }
        }
    }

    static fromJS(data: any): ShippingSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["earliestDeliveryDate"] = this.earliestDeliveryDate;
        data["latestDeliveryDate"] = this.latestDeliveryDate;
        if (Array.isArray(this.modalities)) {
            data["modalities"] = [];
            for (let item of this.modalities)
                data["modalities"].push(item);
        }
        return data;
    }
}

export interface IShippingSettingsDto {
    /** Fecha de entrega más temprana entre todos los shipments */
    earliestDeliveryDate: string;
    /** Fecha de entrega más tardía entre todos los shipments */
    latestDeliveryDate: string;
    /** Modalidades de envío únicas presentes en la orden */
    modalities: Modalities[];

    [key: string]: any;
}

export class SellerPriceDto implements ISellerPriceDto {
    type!: SellerPriceDtoType;
    value!: number;
    promotionCode?: string;
    percentage?: number;
    name?: string;

    [key: string]: any;

    constructor(data?: ISellerPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.value = _data["value"];
            this.promotionCode = _data["promotionCode"];
            this.percentage = _data["percentage"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SellerPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SellerPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["value"] = this.value;
        data["promotionCode"] = this.promotionCode;
        data["percentage"] = this.percentage;
        data["name"] = this.name;
        return data;
    }
}

export interface ISellerPriceDto {
    type: SellerPriceDtoType;
    value: number;
    promotionCode?: string;
    percentage?: number;
    name?: string;

    [key: string]: any;
}

export class SellerStockDto implements ISellerStockDto {
    quantity!: number;

    [key: string]: any;

    constructor(data?: ISellerStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): SellerStockDto {
        data = typeof data === 'object' ? data : {};
        let result = new SellerStockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface ISellerStockDto {
    quantity: number;

    [key: string]: any;
}

export class CardDto implements ICardDto {
    brand!: CardDtoBrand;
    bin!: string;
    lastPan!: string;

    [key: string]: any;

    constructor(data?: ICardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.brand = _data["brand"];
            this.bin = _data["bin"];
            this.lastPan = _data["lastPan"];
        }
    }

    static fromJS(data: any): CardDto {
        data = typeof data === 'object' ? data : {};
        let result = new CardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["brand"] = this.brand;
        data["bin"] = this.bin;
        data["lastPan"] = this.lastPan;
        return data;
    }
}

export interface ICardDto {
    brand: CardDtoBrand;
    bin: string;
    lastPan: string;

    [key: string]: any;
}

export class ShippingConfigDto implements IShippingConfigDto {
    modality!: ShippingConfigDtoModality;
    dispatchType!: ShippingConfigDtoDispatchType;
    deliveryDate!: string;
    startDateWindow!: string;
    endDateWindow!: string;
    status!: string;
    cost!: number;
    pickupPoint?: PickupPointDto;
    origin!: ShippingOriginDto;

    [key: string]: any;

    constructor(data?: IShippingConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.origin = new ShippingOriginDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.modality = _data["modality"];
            this.dispatchType = _data["dispatchType"];
            this.deliveryDate = _data["deliveryDate"];
            this.startDateWindow = _data["startDateWindow"];
            this.endDateWindow = _data["endDateWindow"];
            this.status = _data["status"];
            this.cost = _data["cost"];
            this.pickupPoint = _data["pickupPoint"] ? PickupPointDto.fromJS(_data["pickupPoint"]) : undefined as any;
            this.origin = _data["origin"] ? ShippingOriginDto.fromJS(_data["origin"]) : new ShippingOriginDto();
        }
    }

    static fromJS(data: any): ShippingConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["modality"] = this.modality;
        data["dispatchType"] = this.dispatchType;
        data["deliveryDate"] = this.deliveryDate;
        data["startDateWindow"] = this.startDateWindow;
        data["endDateWindow"] = this.endDateWindow;
        data["status"] = this.status;
        data["cost"] = this.cost;
        data["pickupPoint"] = this.pickupPoint ? this.pickupPoint.toJSON() : undefined as any;
        data["origin"] = this.origin ? this.origin.toJSON() : undefined as any;
        return data;
    }
}

export interface IShippingConfigDto {
    modality: ShippingConfigDtoModality;
    dispatchType: ShippingConfigDtoDispatchType;
    deliveryDate: string;
    startDateWindow: string;
    endDateWindow: string;
    status: string;
    cost: number;
    pickupPoint?: PickupPointDto;
    origin: ShippingOriginDto;

    [key: string]: any;
}

export class ShippingInformationDto implements IShippingInformationDto {
    deliveryCompany!: string;

    [key: string]: any;

    constructor(data?: IShippingInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.deliveryCompany = _data["deliveryCompany"];
        }
    }

    static fromJS(data: any): ShippingInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["deliveryCompany"] = this.deliveryCompany;
        return data;
    }
}

export interface IShippingInformationDto {
    deliveryCompany: string;

    [key: string]: any;
}

export class OrderItemDto implements IOrderItemDto {
    id!: string;
    sequence!: number;
    origin!: ShippingOriginDto;
    type!: OrderItemDtoType;
    /** Información del producto cuando el item es REGULAR o GIFT */
    product?: OrderItemProductDto;
    /** Información del servicio cuando el item es SERVICE */
    service?: OrderItemServiceDto;
    linkedItemId?: string;
    quantity!: number;
    appliedDiscounts!: AppliedDiscountDto[];
    unitPrice!: number;
    subtotal!: number;
    totalAppliedDiscount!: number;
    total!: number;

    [key: string]: any;

    constructor(data?: IOrderItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.origin = new ShippingOriginDto();
            this.appliedDiscounts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.sequence = _data["sequence"];
            this.origin = _data["origin"] ? ShippingOriginDto.fromJS(_data["origin"]) : new ShippingOriginDto();
            this.type = _data["type"];
            this.product = _data["product"] ? OrderItemProductDto.fromJS(_data["product"]) : undefined as any;
            this.service = _data["service"] ? OrderItemServiceDto.fromJS(_data["service"]) : undefined as any;
            this.linkedItemId = _data["linkedItemId"];
            this.quantity = _data["quantity"];
            if (Array.isArray(_data["appliedDiscounts"])) {
                this.appliedDiscounts = [] as any;
                for (let item of _data["appliedDiscounts"])
                    this.appliedDiscounts!.push(AppliedDiscountDto.fromJS(item));
            }
            this.unitPrice = _data["unitPrice"];
            this.subtotal = _data["subtotal"];
            this.totalAppliedDiscount = _data["totalAppliedDiscount"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): OrderItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["sequence"] = this.sequence;
        data["origin"] = this.origin ? this.origin.toJSON() : undefined as any;
        data["type"] = this.type;
        data["product"] = this.product ? this.product.toJSON() : undefined as any;
        data["service"] = this.service ? this.service.toJSON() : undefined as any;
        data["linkedItemId"] = this.linkedItemId;
        data["quantity"] = this.quantity;
        if (Array.isArray(this.appliedDiscounts)) {
            data["appliedDiscounts"] = [];
            for (let item of this.appliedDiscounts)
                data["appliedDiscounts"].push(item ? item.toJSON() : undefined as any);
        }
        data["unitPrice"] = this.unitPrice;
        data["subtotal"] = this.subtotal;
        data["totalAppliedDiscount"] = this.totalAppliedDiscount;
        data["total"] = this.total;
        return data;
    }
}

export interface IOrderItemDto {
    id: string;
    sequence: number;
    origin: ShippingOriginDto;
    type: OrderItemDtoType;
    /** Información del producto cuando el item es REGULAR o GIFT */
    product?: OrderItemProductDto;
    /** Información del servicio cuando el item es SERVICE */
    service?: OrderItemServiceDto;
    linkedItemId?: string;
    quantity: number;
    appliedDiscounts: AppliedDiscountDto[];
    unitPrice: number;
    subtotal: number;
    totalAppliedDiscount: number;
    total: number;

    [key: string]: any;
}

export class PickupPointDto implements IPickupPointDto {
    id!: string;
    type!: PickupPointDtoType;
    name!: string;
    address!: string;
    schedule?: string;
    latitude!: number;
    longitude!: number;
    /** Distancia en Km desde el cliente (cuando aplique) */
    distanceInKm?: number;

    [key: string]: any;

    constructor(data?: IPickupPointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.type = _data["type"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.schedule = _data["schedule"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.distanceInKm = _data["distanceInKm"];
        }
    }

    static fromJS(data: any): PickupPointDto {
        data = typeof data === 'object' ? data : {};
        let result = new PickupPointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["type"] = this.type;
        data["name"] = this.name;
        data["address"] = this.address;
        data["schedule"] = this.schedule;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["distanceInKm"] = this.distanceInKm;
        return data;
    }
}

export interface IPickupPointDto {
    id: string;
    type: PickupPointDtoType;
    name: string;
    address: string;
    schedule?: string;
    latitude: number;
    longitude: number;
    /** Distancia en Km desde el cliente (cuando aplique) */
    distanceInKm?: number;

    [key: string]: any;
}

export class ShippingOriginDto implements IShippingOriginDto {
    type!: ShippingOriginDtoType;
    code!: string;
    name!: string;

    [key: string]: any;

    constructor(data?: IShippingOriginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ShippingOriginDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingOriginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface IShippingOriginDto {
    type: ShippingOriginDtoType;
    code: string;
    name: string;

    [key: string]: any;
}

export class OrderItemProductDto implements IOrderItemProductDto {
    id!: string;
    externalId!: string;
    name!: string;
    sellerId!: string;
    seller!: string;
    brandId!: string;
    brand!: string;
    categoryId!: string;
    category!: string;
    sku!: string;
    skuType!: OrderItemProductDtoSkuType;
    ean!: string;
    measurementUnit!: OrderItemProductDtoMeasurementUnit;
    unitConversionFactor!: number;
    /** Indica si el producto es un pack */
    pack!: boolean;
    image!: ProductImageDto;
    packItems?: PackItemDto[];

    [key: string]: any;

    constructor(data?: IOrderItemProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.image = new ProductImageDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.externalId = _data["externalId"];
            this.name = _data["name"];
            this.sellerId = _data["sellerId"];
            this.seller = _data["seller"];
            this.brandId = _data["brandId"];
            this.brand = _data["brand"];
            this.categoryId = _data["categoryId"];
            this.category = _data["category"];
            this.sku = _data["sku"];
            this.skuType = _data["skuType"];
            this.ean = _data["ean"];
            this.measurementUnit = _data["measurementUnit"];
            this.unitConversionFactor = _data["unitConversionFactor"];
            this.pack = _data["pack"];
            this.image = _data["image"] ? ProductImageDto.fromJS(_data["image"]) : new ProductImageDto();
            if (Array.isArray(_data["packItems"])) {
                this.packItems = [] as any;
                for (let item of _data["packItems"])
                    this.packItems!.push(PackItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderItemProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["externalId"] = this.externalId;
        data["name"] = this.name;
        data["sellerId"] = this.sellerId;
        data["seller"] = this.seller;
        data["brandId"] = this.brandId;
        data["brand"] = this.brand;
        data["categoryId"] = this.categoryId;
        data["category"] = this.category;
        data["sku"] = this.sku;
        data["skuType"] = this.skuType;
        data["ean"] = this.ean;
        data["measurementUnit"] = this.measurementUnit;
        data["unitConversionFactor"] = this.unitConversionFactor;
        data["pack"] = this.pack;
        data["image"] = this.image ? this.image.toJSON() : undefined as any;
        if (Array.isArray(this.packItems)) {
            data["packItems"] = [];
            for (let item of this.packItems)
                data["packItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOrderItemProductDto {
    id: string;
    externalId: string;
    name: string;
    sellerId: string;
    seller: string;
    brandId: string;
    brand: string;
    categoryId: string;
    category: string;
    sku: string;
    skuType: OrderItemProductDtoSkuType;
    ean: string;
    measurementUnit: OrderItemProductDtoMeasurementUnit;
    unitConversionFactor: number;
    /** Indica si el producto es un pack */
    pack: boolean;
    image: ProductImageDto;
    packItems?: PackItemDto[];

    [key: string]: any;
}

export class OrderItemServiceDto implements IOrderItemServiceDto {
    serviceCode!: string;
    serviceType!: OrderItemServiceDtoServiceType;
    description!: string;
    sellerId!: string;
    seller!: string;

    [key: string]: any;

    constructor(data?: IOrderItemServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.serviceCode = _data["serviceCode"];
            this.serviceType = _data["serviceType"];
            this.description = _data["description"];
            this.sellerId = _data["sellerId"];
            this.seller = _data["seller"];
        }
    }

    static fromJS(data: any): OrderItemServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["serviceCode"] = this.serviceCode;
        data["serviceType"] = this.serviceType;
        data["description"] = this.description;
        data["sellerId"] = this.sellerId;
        data["seller"] = this.seller;
        return data;
    }
}

export interface IOrderItemServiceDto {
    serviceCode: string;
    serviceType: OrderItemServiceDtoServiceType;
    description: string;
    sellerId: string;
    seller: string;

    [key: string]: any;
}

export class AppliedDiscountDto implements IAppliedDiscountDto {
    id!: string;
    code!: string;
    coupon?: any;
    order!: number;
    name!: string;
    type!: AppliedDiscountDtoType;
    value!: number;
    calculatedAmount!: number;

    [key: string]: any;

    constructor(data?: IAppliedDiscountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.code = _data["code"];
            this.coupon = _data["coupon"];
            this.order = _data["order"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.value = _data["value"];
            this.calculatedAmount = _data["calculatedAmount"];
        }
    }

    static fromJS(data: any): AppliedDiscountDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppliedDiscountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["code"] = this.code;
        data["coupon"] = this.coupon;
        data["order"] = this.order;
        data["name"] = this.name;
        data["type"] = this.type;
        data["value"] = this.value;
        data["calculatedAmount"] = this.calculatedAmount;
        return data;
    }
}

export interface IAppliedDiscountDto {
    id: string;
    code: string;
    coupon?: any;
    order: number;
    name: string;
    type: AppliedDiscountDtoType;
    value: number;
    calculatedAmount: number;

    [key: string]: any;
}

export class ProductImageDto implements IProductImageDto {
    /** URL de la imagen del producto */
    url!: string;
    /** Texto alternativo de la imagen */
    altText!: string;

    [key: string]: any;

    constructor(data?: IProductImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.url = _data["url"];
            this.altText = _data["altText"];
        }
    }

    static fromJS(data: any): ProductImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["url"] = this.url;
        data["altText"] = this.altText;
        return data;
    }
}

export interface IProductImageDto {
    /** URL de la imagen del producto */
    url: string;
    /** Texto alternativo de la imagen */
    altText: string;

    [key: string]: any;
}

export class PackItemDto implements IPackItemDto {
    id!: string;
    externalId!: string;
    name!: string;
    brandId!: string;
    brand!: string;
    categoryId!: string;
    category!: string;
    sku!: string;
    skuType!: PackItemDtoSkuType;
    ean!: string;
    measurementUnit!: PackItemDtoMeasurementUnit;
    /** Factor de conversión de unidad */
    unitConversionFactor!: number;
    quantity!: number;
    unitPrice!: number;

    [key: string]: any;

    constructor(data?: IPackItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.externalId = _data["externalId"];
            this.name = _data["name"];
            this.brandId = _data["brandId"];
            this.brand = _data["brand"];
            this.categoryId = _data["categoryId"];
            this.category = _data["category"];
            this.sku = _data["sku"];
            this.skuType = _data["skuType"];
            this.ean = _data["ean"];
            this.measurementUnit = _data["measurementUnit"];
            this.unitConversionFactor = _data["unitConversionFactor"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
        }
    }

    static fromJS(data: any): PackItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["externalId"] = this.externalId;
        data["name"] = this.name;
        data["brandId"] = this.brandId;
        data["brand"] = this.brand;
        data["categoryId"] = this.categoryId;
        data["category"] = this.category;
        data["sku"] = this.sku;
        data["skuType"] = this.skuType;
        data["ean"] = this.ean;
        data["measurementUnit"] = this.measurementUnit;
        data["unitConversionFactor"] = this.unitConversionFactor;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        return data;
    }
}

export interface IPackItemDto {
    id: string;
    externalId: string;
    name: string;
    brandId: string;
    brand: string;
    categoryId: string;
    category: string;
    sku: string;
    skuType: PackItemDtoSkuType;
    ean: string;
    measurementUnit: PackItemDtoMeasurementUnit;
    /** Factor de conversión de unidad */
    unitConversionFactor: number;
    quantity: number;
    unitPrice: number;

    [key: string]: any;
}

export enum OrderDetailResponseDtoStatus {
    CREATED = "CREATED",
    PAYMENT_INITIATED = "PAYMENT_INITIATED",
    CONFIRMED = "CONFIRMED",
    HANDLING_INITIATED = "HANDLING_INITIATED",
    HANDLING_FINISHED = "HANDLING_FINISHED",
    INVOICED = "INVOICED",
    VOIDED = "VOIDED",
    IN_TRANSIT = "IN_TRANSIT",
    AT_DELIVERY_LOCATION = "AT_DELIVERY_LOCATION",
    DELIVERED = "DELIVERED",
    CANCELED = "CANCELED",
}

export enum OrderSummaryDtoStatus {
    CREATED = "CREATED",
    PAYMENT_INITIATED = "PAYMENT_INITIATED",
    CONFIRMED = "CONFIRMED",
    HANDLING_INITIATED = "HANDLING_INITIATED",
    HANDLING_FINISHED = "HANDLING_FINISHED",
    INVOICED = "INVOICED",
    VOIDED = "VOIDED",
    IN_TRANSIT = "IN_TRANSIT",
    AT_DELIVERY_LOCATION = "AT_DELIVERY_LOCATION",
    DELIVERED = "DELIVERED",
    CANCELED = "CANCELED",
}

export enum TotalsDtoCurrency {
    USD = "USD",
    PEN = "PEN",
}

export enum CustomerDtoDocumentType {
    DNI = "DNI",
    CE = "CE",
    PASSPORT = "PASSPORT",
    RUC = "RUC",
}

export enum BillingDtoReceiptType {
    INVOICE = "INVOICE",
    RECEIPT = "RECEIPT",
}

export enum PaymentDtoStatus {
    PENDING = "PENDING",
    AUTHORIZED = "AUTHORIZED",
    CAPTURED = "CAPTURED",
    REJECTED = "REJECTED",
    REFUNDED = "REFUNDED",
    CANCELLED = "CANCELLED",
}

export enum PaymentDtoMethodType {
    CREDIT_CARD = "CREDIT_CARD",
    DEBIT_CARD = "DEBIT_CARD",
    CASH = "CASH",
    BANK_TRANSFER = "BANK_TRANSFER",
    DIGITAL_WALLET = "DIGITAL_WALLET",
}

export enum PaymentDtoPaymentMethod {
    CREDIT_CARD = "CREDIT_CARD",
    DEBIT_CARD = "DEBIT_CARD",
    CASH = "CASH",
    BANK_TRANSFER = "BANK_TRANSFER",
    DIGITAL_WALLET = "DIGITAL_WALLET",
}

export enum Modalities {
    HOME_DELIVERY = "HOME_DELIVERY",
    PICKUP_IN_STORE = "PICKUP_IN_STORE",
}

export enum SellerPriceDtoType {
    REGULAR = "REGULAR",
    OFFER = "OFFER",
    PROMOTIONAL = "PROMOTIONAL",
}

export enum CardDtoBrand {
    VISA = "VISA",
    MASTERCARD = "MASTERCARD",
    AMEX = "AMEX",
    DINERS = "DINERS",
}

export enum ShippingConfigDtoModality {
    HOME_DELIVERY = "HOME_DELIVERY",
    PICKUP_IN_STORE = "PICKUP_IN_STORE",
}

export enum ShippingConfigDtoDispatchType {
    NORMAL = "NORMAL",
    EXPRESS = "EXPRESS",
    SCHEDULED = "SCHEDULED",
}

export enum OrderItemDtoType {
    REGULAR = "REGULAR",
    GIFT = "GIFT",
    SERVICE = "SERVICE",
}

export enum PickupPointDtoType {
    BRANCH = "BRANCH",
}

export enum ShippingOriginDtoType {
    WAREHOUSE = "WAREHOUSE",
    BRANCH = "BRANCH",
    DISTRIBUTION_CENTER = "DISTRIBUTION_CENTER",
}

export enum OrderItemProductDtoSkuType {
    REGULAR = "REGULAR",
    PRESENTATION = "PRESENTATION",
    BUNDLE = "BUNDLE",
    SERVICE = "SERVICE",
}

export enum OrderItemProductDtoMeasurementUnit {
    GRAM = "GRAM",
    UNIT = "UNIT",
    KILOGRAM = "KILOGRAM",
    MILLIGRAM = "MILLIGRAM",
    METER = "METER",
    SQUARE_METER = "SQUARE_METER",
    CUBIC_METER = "CUBIC_METER",
    CENTIMETER = "CENTIMETER",
    SQUARE_CENTIMETER = "SQUARE_CENTIMETER",
    CUBIC_CENTIMETER = "CUBIC_CENTIMETER",
    MILLIMETER = "MILLIMETER",
    SQUARE_MILLIMETER = "SQUARE_MILLIMETER",
    CUBIC_MILLIMETER = "CUBIC_MILLIMETER",
    OUNCE = "OUNCE",
    POUND = "POUND",
    FOOT = "FOOT",
    SQUARE_FOOT = "SQUARE_FOOT",
    CUBIC_FOOT = "CUBIC_FOOT",
}

export enum OrderItemServiceDtoServiceType {
    INSTALLATION = "INSTALLATION",
    WARRANTY = "WARRANTY",
    SHIPPING = "SHIPPING",
    PLATFORM_FEE = "PLATFORM_FEE",
}

export enum AppliedDiscountDtoType {
    PERCENTAGE = "PERCENTAGE",
    FIXED_AMOUNT = "FIXED_AMOUNT",
}

export enum PackItemDtoSkuType {
    REGULAR = "REGULAR",
    PRESENTATION = "PRESENTATION",
    BUNDLE = "BUNDLE",
    SERVICE = "SERVICE",
}

export enum PackItemDtoMeasurementUnit {
    GRAM = "GRAM",
    UNIT = "UNIT",
    KILOGRAM = "KILOGRAM",
    MILLIGRAM = "MILLIGRAM",
    METER = "METER",
    SQUARE_METER = "SQUARE_METER",
    CUBIC_METER = "CUBIC_METER",
    CENTIMETER = "CENTIMETER",
    SQUARE_CENTIMETER = "SQUARE_CENTIMETER",
    CUBIC_CENTIMETER = "CUBIC_CENTIMETER",
    MILLIMETER = "MILLIMETER",
    SQUARE_MILLIMETER = "SQUARE_MILLIMETER",
    CUBIC_MILLIMETER = "CUBIC_MILLIMETER",
    OUNCE = "OUNCE",
    POUND = "POUND",
    FOOT = "FOOT",
    SQUARE_FOOT = "SQUARE_FOOT",
    CUBIC_FOOT = "CUBIC_FOOT",
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}